import app from '@m-common/utils'
import store from '@m-common/store'

const checkRunEnv = new Promise(rsv => {
    if (app.env === 'wx') {
        wx.miniProgram.getEnv(res => {
            if (res.miniprogram) {
                // 微信小程序环境
                app.envType = 4
            } else {
                //微信环境
                app.envType = 0
            }
            rsv()
        })
    } else {
        rsv()
    }
})

// 微信jssdk and app token
const wxsdkPromise = new Promise(resolve => {
    // 校管家app环境不需要微信jssdk
    if (app.env === 'xgj') {
        const appVersion = app.sdk.getAppVersion()
        if (appVersion < 3.2) {
            resolve()
        } else {
            app.sdk.getAppToken().then(token => {
                store.commit('setToken', token)
                resolve()
            })
        }
        return
    }
    checkRunEnv.then(() => {
        resolve()
    })
})

wxsdkPromise.then(() => {
    import(/*webpackChunkName: "index"*/ './index.js')
})
